import LocalStorageSupport from '../web/LocalStorageSupport';
import $ from 'jquery';
import StringBuffer from '../web/StringBuffer';
import moment from 'moment';

require('moment-range');

const ls = new LocalStorageSupport();
const STORE_KEY = 'KM_APP_GRAV_CALC';
const INITIAL_STATE = {
  appName: 'Grav Calculator',
  version: '1.0'
};

const i18n = {
  birthDate: 'Znám předpokládaný datum narození',
  menstruationDate1: 'Neznám datum narození',
  menstruationDate2: '(Zadejte první den vaší poslední menstruace. Vypočítá předpokládané datum porodu.)',
  date: 'Zadejte datum',
  submit: {
    loggedIn: 'Spočítat',
    notLoggedIn: 'Pokračovat',
    continue: 'Pokračovat'
  },
  errors: {
    OUT_OF_RANGE: 'Na základě zadaného datumu nelze vypočítat datum těhotenství.'
  }
};

export default class GravCalc {
  constructor(elId, inputData) {
    this.$t = $(elId);
    this.landingPages = inputData;
    this.loggedIn = window.user && window.user.logged;
    this.initialise();
  }

  initialise() {
    this.state = this.getInitialState();
    this.resetComputedWeek();
    this.renderApp();
    this.handleCalcButton();
  }

  getInitialState() {
    return JSON.parse(ls.getItem(STORE_KEY)) || INITIAL_STATE;
  }

  setState(newState) {
    this.state = $.extend({}, this.state, newState);
    this.storeState();
  }

  storeState() {
    ls.setItem(STORE_KEY, JSON.stringify(this.state));
  }

  resetComputedWeek() {
    this.setState({
      computedWeek: null
    });
  }

  renderApp() {
    this.$t.append(this.template());
    this.restoreDataFromState();
    $('body').trigger('JS_PICKMEUP_DATEPICKER');
  }

  restoreDataFromState() {
    const dateType = this.state.userSelectedDateType;
    const date = this.state.userSelectedDate;

    if (dateType && dateType != null && date && date != null) {
      $(`input[value="${dateType}"]`, this.$t).attr('checked', 'checked');
      $('#date', this.$t).val(date);
      if (this.loggedIn) {
        $('#send', this.$t).html(i18n.submit.continue);
      }
    }
  }

  renderError(errorIndex) {
    $('.error-data', this.$t).text(i18n.errors[errorIndex]).removeClass('hidden');
  }

  removeError() {
    $('.error-data', this.$t).empty().addClass('hidden');
  }

  handleCalcButton() {
    const self_ = this;
    $('#send', this.$t).on('click', (e) => {
      e.preventDefault();
      const dateType = $('input[name=dateType]:checked', self_.$t).val();
      const originalDate = moment($('#date', self_.$t).val(), ['DD. MM. YYYY', 'YYYY-MM-DD']);
      let date = moment($('#date', self_.$t).val(), ['DD. MM. YYYY', 'YYYY-MM-DD']);


      // add 280 days if birthDate is not known
      date = dateType == 1 ? date.subtract(280, 'days') : date;
      const range = moment.range(date, new Date());
      const diffInDays = range.diff('days');
      let diffInWeeks = 0;

      // datum početí nesmí být v budoucnosti
      if (diffInDays <= 0) {
        self_.renderError('OUT_OF_RANGE');
      } else {
        diffInWeeks = Math.ceil(diffInDays / 7);
        self_.calcResolution(diffInWeeks, date.add(280, 'days').format('DD. MM. YYYY'), dateType, originalDate.format('DD. MM. YYYY'));
      }
    });
  }

  calcResolution(value, date, dateType, originalDate) {
    this.removeError();
    // pokud neexistuje článek (týden), vyhodíme chybu o neúspěšném výpočtu týdne
    if (!this.landingPages[`lp${value}`]) {
      this.renderError('OUT_OF_RANGE');
      return false;
    }

    this.setState({
      computedWeek: value,
      userSelectedDateType: dateType,
      userSelectedDate: originalDate
    });

    if (this.loggedIn) {
      window.location.href = this.landingPages[`lp${value}`].url;
    } else {
      window.location.href = this.landingPages[`lp${value}`].url;
      // window.location.href = '/cs/registrace?app=gc&frm.child_birthDate=' + encodeURI(date);
    }
  }

  template() {
    const sb = new StringBuffer();
    const submitText = this.loggedIn ?
      i18n.submit.loggedIn :
      i18n.submit.notLoggedIn;

    const enhancedScrolling = this.loggedIn ? '' : ' js_last_visited_url_enhancement_launcher';


    sb.append('<div class="app-wrapper js_last_visited_url_enhancement_target">');
    sb.append('	<div class="app-in form-grav-calc">');
    sb.append(`		<div class="checkbox"><input type="radio" class="mask-disclaimer" value="1" checked name="dateType" id="app-gc-birth-date"/><label for="app-gc-birth-date"><strong>${i18n.birthDate}</strong></label></div>`);
    sb.append(`		<div class="checkbox less-line-height"><input type="radio" class="mask-disclaimer" value="2" name="dateType" id="app-gc-menstruation-date"/><label for="app-gc-menstruation-date"><strong>${i18n.menstruationDate1}</strong> ${i18n.menstruationDate2}</label></div>`);
    sb.append('		<p>');
    sb.append(`<label for="date" class="touch-hidden">${i18n.date}</label><input type="text" readonly class="js_dateinput" id="date" placeholder="${i18n.date}"/>`);
    sb.append(`<button id="send" class="btn btn-default${enhancedScrolling}">${submitText}</button>`);
    sb.append('		</p>');
    sb.append('	</div>');
    sb.append('	<div class="error-data hidden"></div>');
    sb.append('</div>');

    return sb.getString();
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/apps/GravCalc.js